import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const AcquisitionsHomePage = lazyNamed(() => import('./pages'), 'AcquisitionsHomePage');
const VendorsPage = lazyNamed(() => import('./pages'), 'VendorsPage');
const VendorDetailPage = lazyNamed(() => import('./pages'), 'VendorDetailPage');
const FundsPage = lazyNamed(() => import('./pages'), 'FundsPage');
const BasketsPage = lazyNamed(() => import('./pages'), 'BasketsPage');
const BasketDetailPage = lazyNamed(() => import('./pages'), 'BasketDetailPage');
const OrdersPage = lazyNamed(() => import('./pages'), 'OrdersPage');
const InvoicesPage = lazyNamed(() => import('./pages'), 'InvoicesPage');
const SuggestionsPage = lazyNamed(() => import('./pages'), 'SuggestionsPage');
const ReceivingPage = lazyNamed(() => import('./pages'), 'ReceivingPage');

/**
 * Staff routes for features/acquisitions. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const acquisitionsRoutes: RouteObject[] = [
  { path: 'acquisitions', element: <RequirePermission permission={['acquisition']}><AcquisitionsHomePage /></RequirePermission> },
  { path: 'acquisitions/vendors', element: <RequirePermission permission={['acquisition']}><VendorsPage /></RequirePermission> },
  { path: 'acquisitions/vendors/:id', element: <RequirePermission permission={['acquisition']}><VendorDetailPage /></RequirePermission> },
  { path: 'acquisitions/funds', element: <RequirePermission permission={['acquisition']}><FundsPage /></RequirePermission> },
  { path: 'acquisitions/baskets', element: <RequirePermission permission={['acquisition']}><BasketsPage /></RequirePermission> },
  { path: 'acquisitions/baskets/:id', element: <RequirePermission permission={['acquisition']}><BasketDetailPage /></RequirePermission> },
  { path: 'acquisitions/orders', element: <RequirePermission permission={['acquisition']}><OrdersPage /></RequirePermission> },
  { path: 'acquisitions/invoices', element: <RequirePermission permission={['acquisition']}><InvoicesPage /></RequirePermission> },
  { path: 'acquisitions/suggestions', element: <RequirePermission permission={['acquisition']}><SuggestionsPage /></RequirePermission> },
  { path: 'acquisitions/receiving', element: <RequirePermission permission={['acquisition']}><ReceivingPage /></RequirePermission> },
];
